module.exports = __webpack_public_path__ + "static/media/email_icon.3f0a961f.svg";